//# sourceMappingURL=my-month-labels.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mydaterangepicker/dist/interfaces/my-month-labels.interface.js
// module id = 1014
// module chunks = 3